import { render, staticRenderFns } from "./MagazzinoArticoliStoricoMovimentazioneGiacenzaComponent.vue?vue&type=template&id=411311db&scoped=true"
import script from "./MagazzinoArticoliStoricoMovimentazioneGiacenzaComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliStoricoMovimentazioneGiacenzaComponent.vue?vue&type=script&lang=js"
import style0 from "./MagazzinoArticoliStoricoMovimentazioneGiacenzaComponent.vue?vue&type=style&index=0&id=411311db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411311db",
  null
  
)

export default component.exports